import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewRef
} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {CollaborationService} from "../../../services/Collaboration.service";
import {ToastService} from "../../../services/Toast.service";
import {FileUploader, FileUploaderOptions, FileUploadModule} from "ng2-file-upload";
import {DateFormater} from "../../../services/DateFormatter.service";
import {SwitchBoard} from "../../../services/SwitchBoard";
import {LoadingService} from "../../../services/LoadingService";
import {TOAST_TYPE} from "../../../constants/Tpiq.constants";
import {ManageTaxStrategiesServices} from "../../../tpiq-services/manage-tax-strategies.service";
import {takeUntil} from "rxjs/operators";
import {Session} from "../../../services/Session";
import FroalaEditor from 'froala-editor';
import {FroalaEditorModule, FroalaViewModule} from "angular-froala-wysiwyg";
import {LabelInputSearchComponent} from "../label-input-search/label-input-search.component";
import {ClickOutsideDirective} from "../../../directives/click.outside";
import {SubCommentComponent} from "../sub-comment/sub-comment.component";
import {LinkyModule} from "ngx-linky";
import { environment } from '../../../../environments/environment';

declare const jQuery: any;
declare const _: any;
declare const moment: any;

@Component({
  selector: 'app-comment',
  standalone: true,
  imports: [CommonModule, FormsModule, FileUploadModule, FroalaEditorModule, FroalaViewModule, LabelInputSearchComponent, ClickOutsideDirective,
    SubCommentComponent, LinkyModule],
  templateUrl: './comment.component.html',
  styleUrl: './comment.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommentComponent implements OnInit, OnDestroy {
  @Input() org: string;
  @Input() companyId: string;
  @Input() entityType: string;
  @Input() entityID: string;
  @Input() comment: any;
  @Input() taskId: string;
  @Input() postId: string;
  @Input() user: any;
  @Input() isDocView: boolean;
  @Input() pageType: string;
  @Input() channelType: string;
  @Input() collaborationAccess: boolean;
  @Input() clientInternalUsers: any;
  @Output() onDeleteComment: EventEmitter<any> = new EventEmitter<any>();
  @Output() onFolderClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() onOpenDocument: EventEmitter<any> = new EventEmitter<any>();
  @Output() onRefreshPost: EventEmitter<void> = new EventEmitter<void>();

  generatedId: string;
  uploader: any;
  updateObj: any = {};
  showReplySection = false;
  reveal: any = {
    onMove: false,
    uploadDocument: false,
    mailAttach: false
  };
  filters: any = {
    task: '#4ab9e8',
    done: '#1CB3AB',
    working: '#FDB844',
    active: '#CD0814',
    celebrating: '#ef655d'
  };
  displayUserInfoWidget = false;
  postUploadResp: Array<any> = [];
  badges: any = [
    {name: 'task', icon: 'grade', selected: false, color: '#4ab9e8'},
    {name: 'done', icon: 'check_circle', selected: false, color: '#1CB3AB'},
    {name: 'working', icon: 'watch_later', selected: false, color: '#FDB844'},
    {name: 'active', icon: 'alarm_add', selected: false, color: '#CD0814'},
    {
      name: 'celebrating',
      icon: 'insert_emoticon',
      selected: false,
      color: '#ef655d'
    }
  ];
  hideReplies = true;
  searchString: string;
  pdfLink: string;
  uploadCount = 0;
  uploadingDocumentName: string;
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  isTpiqOrgUser = false;
  placeHolder = 'Write A comment';
  messageHeight = true;
  attachmentId = '';
  attachmentComment: any = {};
  users: Array<any> = [];
  allUsers: Array<any> = [];
  showMentionDropdown = false;
  mentionUsers: Array<any> = [];
  mentionIds: Array<any> = [];
  mentions: Array<any> = [];
  subComment = '';
  toggledGiphy = false;
  isGify = false;
  gifyUrl: any;
  toggledEditGiphy = false;
  isEditGify = false;
  editGifyUrl: any;
  editor: any;
  editorOptions = {
    autofocus: true,
    listAdvancedTypes: false,
    linkAlwaysBlank: true,
    toolbarInline: true,
    enter: FroalaEditor.ENTER_DIV,
    colorsText: ['#14B5F0', '#3574e3', '#DFCF6A', '#2D62BF', '#09A4DE', '#475E79', '#3474e3', '#102D79', '#434343'],
    key: environment.froalaKey,
    pasteDeniedAttrs: ['class', 'id', 'style'],
    imageUploadRemoteUrls: false,
    events: {
      initialized: (e) => {
        this.editor = e.getEditor();
        this.editor.events.on('keydown', (keydownEvent: any) => {
          if (!keydownEvent.shiftKey && keydownEvent.keyCode === 13) {
            this.onUpdateEnter(keydownEvent, 'comment');
          }
        }, true);

        this.editor.events.on('drop', (dropEvent: any) => {
          dropEvent.preventDefault();
          return false;
        }, true);

        this.editor.events.on('paste.afterCleanup', (clipboard_html) => {
          const span = document.createElement('span');
          span.innerHTML = clipboard_html;
          const children = span.querySelectorAll('*');
          for (let i = 0 ; i < children.length ; i++) {
            if (jQuery(children[i]).is('br') &&  jQuery(children[i + 1]).is('br')) {
              children[i].remove();
            }
            if (jQuery(children[i]).is('li') && jQuery(children[i]).innerText == '') {
              children[i].remove();
            }
          }
          return span.innerHTML;
        }, true);

        this.editor.events.on('image.beforePasteUpload', (img) => {
          const base64 = img.getAttribute('src');
          const arr = base64.split(',');
          const mime = arr[0].match(/:(.*?);/)[1];
          const exactMime = mime.split('/')[1];
          const imageName = 'image_' + Math.floor((Math.random() * 100) + 1) + '.' + exactMime;
          const base = this;
          this.urltoFile(base64, imageName, mime)
            .then((file: any) => {
              const files: any = [];
              files.push(file);
              base.uploader.addToQueue(files);
              base.startUpload(img, base.comment.id);
            });
          this.editor.html.set(base.updateObj.message);
          return false;
        }, true);
      }
    },
    toolbarButtons: ['bold', 'italic', 'underline', 'color', 'formatOL', 'formatUL', 'quote', 'insertLink'],
    placeholderText: 'Write A comment ...',
    charCounterCount: false,
    quickInsertTags: [],
    zIndex: 1,
    theme: 'royal'
  };
  documentsIds: Array<any> = [];
  documentsData: Array<any> = [];
  docData: Array<any> = [];

  constructor(private collaborationService: CollaborationService,
              private toastService: ToastService,
              private dateFormatter: DateFormater,
              private loadingService: LoadingService,
              private switchBoard: SwitchBoard,
              private changeDetectorRef: ChangeDetectorRef,
              private changeDetectionRef: ChangeDetectorRef,
              private taxStrategyServices: ManageTaxStrategiesServices) {
  }

  ngOnInit(): void {
    const  base = this;
    if (this.comment) {
      this.comment.tooltipDate = base.updateDateTimeStamp(this.comment.createdDate);
      this.comment.displayDate = base.updateDateTimeStampForTooltip(this.comment.createdDate);
    }
    this._init();
  }

  _init() {
    this.users = Session.getUsers() || [];
    this.isTpiqOrgUser = !this.user.isCustomer;
    this.placeHolder = this.taskId ? 'Make A note' : 'Write A comment';
    this.uploaderUpdate();
    this.buildItemForm();
    this.switchBoard.onToastConfirm
      .pipe(takeUntil(this.destroy$))
      .subscribe((toast: any) => {
        if (toast.data && toast.data.id == this.comment.id) {
          this.deleteAttachment(this.attachmentId, this.attachmentComment);
        }
      });
    setTimeout(() => {
      this.invokeTimeago();
    });

    this.switchBoard.onRevealClose.pipe(takeUntil(this.destroy$)).subscribe(next => {
      this.docData = [];
      this.documentsIds = [];
      this.documentsData = [];
      this.hideReveal(next);
    });
  }

  ngOnDestroy(): void {
    jQuery('.post_options').unbind();
    jQuery('.other-option').unbind();
    jQuery('.remind-me-option').unbind();
    jQuery(`#${this.comment.id}`).remove();
    this.destroy$.next();
    this.destroy$.complete();
  }

  hidePostOptions() {
    jQuery('.post_options')
      .siblings()
      .hide();
  }

  handleCommentAction(action) {
    if (action === 'delete') {
      this.deleteComment();
    } else {
      this.updateObj = {...this.comment, postEntityType: this.entityType, postEntityId: this.entityID};
    }
  }

  deleteComment() {
    this.collaborationService
      .deleteComment(this.comment.id, this.postId)
      .subscribe(
        response => {
          this.onDeleteComment.emit(this.comment.id);
        },
        error => {
        }
      );
  }

  onReplyClick(id) {
    this.showReplySection = !this.showReplySection;
  }

  like(reaction) {
    const data = {
      entityID: this.comment.id,
      entitytype: 'comment',
      id: '',
      userID: Session.getUser().id,
      reaction: reaction
    };
    this.collaborationService
      .like(this.channelType, data, this.companyId, this.org)
      .subscribe(
        response => {
          this.comment = {...this.comment, likedByUser: true, likesCount: ++this.comment.likesCount};
          this.changeDetectorRef.detectChanges();
        },
        error => {
        }
      );
  }

  unLike() {
    this.collaborationService
      .unLike(this.channelType, this.comment.id, this.companyId, this.org)
      .subscribe(
        response => {
          this.comment = {...this.comment, likedByUser: false, likesCount: --this.comment.likesCount};
          this.changeDetectorRef.detectChanges();
        },
        error => {
        }
      );
  }

  downloadDocument(attachment, type) {
    if (attachment.id) {
      this.loadingService.triggerLoadingEvent(true);
      this.taxStrategyServices.downloadDocument(Session.getUser().id, this.org, attachment.id)
        .subscribe(response => {
          this.loadingService.triggerLoadingEvent(false);
          if (type === 'download') {
            window.open(response.temporaryURL);
          } else {
            window.open(response.viewDocContentURL);
          }
        }, error => {
          this.loadingService.triggerLoadingEvent(false);
          const errorMessage = 'Failed to download document';
          this.toastService.pop(TOAST_TYPE.error, errorMessage);
        });
    }

  }

  openImage(attachment) {
    this.onOpenDocument.emit({
      imageType: true,
      isPdf: false,
      selectedImage: `https://documents.taxplaniq.com/${attachment.id}`,
      pdfLink: this.pdfLink
    });
  }

  removeAttachment(attachmentId, obj?) {
    this.attachmentId = attachmentId ? attachmentId : '';
    this.attachmentComment = obj ? obj : {};
    const data = {
      id: obj.id
    };
    this.toastService.pop(TOAST_TYPE.confirm, 'Are you sure you want to delete?', data);
  }

  deleteAttachment(attachmentId, obj?) {
    this.loadingService.triggerLoadingEvent(true);
    this.taxStrategyServices.removeDocument(this.user.id, this.org, attachmentId)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        if (this.comment) {
          _.remove(this.comment.documents, {id: attachmentId});
        } else {
          _.remove(this.postUploadResp, {id: attachmentId});
          if (this.postUploadResp.length === 0) {
            this.resetUploader();
          }
        }
        this.toastService.pop(TOAST_TYPE.success, 'Document Deleted Successfully');
        this.updateCommentData(obj);
        this.changeDetectorRef.detectChanges();
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        try {
          this.toastService.pop(TOAST_TYPE.error, error.message ? error.message : 'Failed to delete document');
        } catch (e) {
          this.toastService.pop(TOAST_TYPE.error, 'Failed to delete document');
        }
      });

  }

  getColor(type) {
    return this.filters[type];
  }

  postSelectBadge(badge, targetObj) {
    if (typeof badge !== 'string') {
      const selectedBadges = _.filter(this.badges, {selected: true});
      targetObj.badges = _.map(selectedBadges, 'name');
    }
  }

  showCommentToggle() {
    this.hideReplies = !this.hideReplies;
  }

  startUpload(type, id?: string) {
    const base = this;
    if (this.uploader.queue.length > 1) {
      setTimeout(() => {
        base.uploader.uploadAll();
      }, 100);
    } else {
      this.uploader.queue.forEach(function(item) {
        base.uploadingDocumentName = item.file.name;
      });
      this.uploadDocument();
      this.changeDetectorRef.detectChanges();
    }
  }

  onUpdateEnter($event, type) {
    $event && $event.preventDefault();
    const base = this;
    if (this.postUploadResp.length > 0) {
      this.updateObj.documents = [];
      for (const i in this.postUploadResp) {
        const obj = {
          name: this.postUploadResp[i].name,
          id: this.postUploadResp[i].id,
          doc_notes: this.postUploadResp[i].documentNotes
            ? this.postUploadResp[i].documentNotes
            : '',
          temporaryURL: this.postUploadResp[i].temporaryURL
        };
        this.updateObj.documents = [...this.updateObj.documents, obj];
      }
    }
    if (!this.updateObj.html_message) {
      this.updateObj.html_message = this.updateObj.message;
    }
    this.updateObj.gifLink = this.gifyUrl;
    this.updateObj.html_message = $event.target.innerHTML;
    this.updateObj.message = $event.target.innerText;
    this.isGify = false;
    this.collaborationService
      .updateComment(this.org, this.channelType, this.updateObj, type, this.companyId)
      .subscribe(
        response => {
          const responsobj = {...this.updateObj};
          responsobj.tooltipDate = base.updateDateTimeStamp(
            responsobj.createdDate
          );
          responsobj.displayDate = base.updateDateTimeStampForTooltip(
            responsobj.createdDate
          );
          responsobj.isBotMessage = false;
          responsobj.children = this.comment.children;
          if (!responsobj.badges) {
            responsobj.badges = [];
          }
          if (responsobj.documents && responsobj.documents.length > 0) {
            _.each(responsobj.documents, function(attachment) {
              const splitArray = attachment.name.split('.');
              if (
                base.isImage(splitArray[splitArray.length - 1]) &&
                attachment.temporaryURL
              ) {
                attachment.imageType = true;
                attachment.displayImage = true;
              }
            });
          }
          this.comment = {...responsobj};
          this.updateObj = {};
          this.changeDetectorRef.detectChanges();
          this.postUploadResp = [];
          this.onRefreshPost.emit();
        },
        error => {
          this.onRefreshPost.emit();
          this.postUploadResp = [];
          this.changeDetectorRef.detectChanges();
          this.stopEditing();
          this.toastService.pop(TOAST_TYPE.error, 'Failed to update Comment');
        }
      );
  }

  isImage(extension) {
    const imageTypes = ['png', 'jpg', 'jpeg', 'bmp'];
    if (imageTypes.indexOf(extension.toLowerCase()) != -1) {
      return true;
    } else {
      return false;
    }
  }

  stopEditing() {
    this.updateObj = {};
    setTimeout(() => {
      this.invokeTimeago();
    });
  }

  updateDateTimeStamp(date) {
    const serviceFormat = 'YYYY-MM-DD HH:mm:ss';
    const dateFormat = 'MM/DD/YYYY HH:mm:ss';
    const startTime = moment.utc(date).toDate();
    return this.dateFormatter.formatDate(startTime, serviceFormat, dateFormat);
  }

  updateDateTimeStampForTooltip(date) {
    const serviceFormat = 'YYYY-MM-DD HH:mm:ss';
    const dateFormat = 'Do MMM, YYYY HH:mm';
    const startTime = moment.utc(date).toDate();
    return this.dateFormatter.formatDate(startTime, serviceFormat, dateFormat);
  }

  onSubCommentEnter(event, comment) {
    const base = this;
    this.showReplySection = false;
    if (this.postUploadResp.length > 0 || (event && event.target.value.length > 0) || base.isEditGify || this.documentsIds.length > 0) {
      const newComment: any = {
        user: {
          firstName: this.user.first_name,
          lastName: this.user.last_name,
          id: this.user.id,
          colorCode: this.user.colorCode,
          bot: false,
          thumbnail:  this.user?.thumbnail?.length > 0 ? this.user.thumbnail : '',
        },
        orgId: Session.getOrg(),
        commentedBy: this.user.id,
        message: (event && event.target.value) ? event.target.value : '',
        postID: comment.postID,
        postInternal: comment.postInternal,
        parentID: comment.id,
        postEntityType: this.entityType,
        postEntityId: this.entityID,
        children: [],
        documents: [],
        mentionIds: []
      };

      if (this.postUploadResp.length > 0) {
        for (const i in this.postUploadResp) {
          const obj = {
            name: this.postUploadResp[i].name,
            id: this.postUploadResp[i].id,
            doc_notes: this.postUploadResp[i].documentNotes
              ? this.postUploadResp[i].documentNotes
              : ''
          };
          newComment.documents = [...newComment.documents, obj];
        }
        newComment.id = this.postUploadResp[0].sourceID;
      } else {
        newComment.id = this.guid();
      }
      if (this.documentsIds.length > 0) {
        newComment.documents = [...newComment.documents, ...this.documentsIds];
      }
      if (base.isEditGify) {
        newComment.gifLink = this.editGifyUrl;
      }
      comment.children = [...comment.children, newComment];
      if (event && event.target.value) {
        event.target.value = '';
      }
      this.subComment = '';
      this.isEditGify = false;
      this.prependMentions(newComment);
      this.collaborationService
        .createComment(this.org, this.channelType, newComment, this.companyId, this.postId, this.taskId)
        .subscribe(
          response => {
            const responseObj = {...response};
            const index = _.findIndex(comment.children, function(children) {
              return children.id === responseObj.id;
            });
            comment.children[index] = responseObj;
            _.each(comment.children, function(comment) {
              comment.tooltipDate = base.updateDateTimeStamp(
                comment.createdDate
              );
              comment.displayDate = base.updateDateTimeStampForTooltip(
                comment.createdDate
              );
            });
            setTimeout(function() {
              base.invokeTimeago();
            });
            this.mentionIds = [];
            this.mentions = [];
            this.allUsers = [];
            this.resetUploader();
            this.postUploadResp = [];
            this.docData = [];
            this.documentsData = [];
            this.documentsIds = [];
            this.hideReplies = false;
          },
          error => {
            this.postUploadResp = [];
            comment.children.splice(-1, 1);
            this.toastService.pop(
              TOAST_TYPE.error,
              'Failed to Post'
            );
          }
        );
    }
  }

  s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }

  guid() {
    return (
      this.s4() +
      this.s4() +
      '-' +
      this.s4() +
      '-' +
      this.s4() +
      '-' +
      this.s4() +
      '-' +
      this.s4() +
      this.s4() +
      this.s4()
    );
  }

  invokeTimeago() {
    jQuery('.post_options').on('mouseover', function($event) {
      jQuery(this)
        .siblings()
        .css('display', 'inline');
    });
    jQuery('.other-option').on('mouseover', function($event) {
      jQuery('.reminder-menu-list').hide();
    });
    jQuery('.remind-me-option').on('mouseover', function($event) {
      jQuery(this)
        .siblings()
        .css('display', 'inline');
    });
  }

  resetUploader() {
    this.uploader.queue.forEach(function(item) {
      item.remove();
    });
  }

  stopPropagation($event) {
    $event && $event.stopImmediatePropagation();
  }

  buildItemForm() {
    this.uploader.onBuildItemForm = (fileItem: any, form: any) => {
      const payload: any = {};
      payload.sourceID = this.generatedId;
      payload.sourceType = (this.channelType == 'orgs') ? 'BROADCAST_POST_COMMENT' : 'TODO_POST_COMMENT';
      form.append('payload', JSON.stringify(payload));
    };
    this.postUploadResp = [];
    this.uploader.onCompleteItem = (item, response, status, header) => {
      if (status === 200) {
        this.uploadCount++;
        this.postUploadResp = [...this.postUploadResp, JSON.parse(response)];
        this.uploader.progress = 100;
        if (this.uploader.queue.length === this.uploadCount) {
          this.toastService.pop(TOAST_TYPE.success, 'Uploaded Successfully');
          this.loadingService.triggerLoadingEvent(false);
          this.uploadCount = 0;
        } else {
          this.toastService.pop(
            TOAST_TYPE.success,
            this.uploadCount +
            '/' +
            this.uploader.queue.length +
            ' Uploaded Successfully'
          );
          this.loadingService.triggerLoadingEvent(false);
        }
      } else {
        this.toastService.pop(TOAST_TYPE.error, 'Error While Uploading');
        this.uploadCount++;
        if (this.uploader.queue.length === this.uploadCount) {
          this.loadingService.triggerLoadingEvent(false);
          this.uploadCount = 0;
        }
      }
    };
  }

  hideReveal(revealFlag) {
    this.reveal[revealFlag] = false;
    if (!(this.changeDetectorRef as ViewRef).destroyed) {
      this.changeDetectorRef.detectChanges();
    }
  }

  updateDocumentToComment() {
    const base = this;
    let documentData = [];
    _.each(this.postUploadResp, function(obj) {
      documentData = [...documentData, {
        id: obj.id,
        name: obj.name,
        temporaryURL: obj.temporaryURL,
        doc_notes: obj.documentNotes ? obj.documentNotes.documentNotes : ''
      }];
    });
    this.collaborationService
      .updateAttachmentInPost(this.channelType, documentData, this.companyId, this.postId)
      .subscribe(
        post => {
          this.resetUploader();
          this.postUploadResp = [];
        },
        error => {
        }
      );
  }

  uploaderUpdate() {
    const docUrl = this.taxStrategyServices.getVideoDocumentServiceUrl(this.org, Session.getUser().id);
    this.uploader = new FileUploader({
      url: docUrl,
      headers: [
        {
          name: 'Authorization',
          value: 'Bearer ' + Session.getToken()
        }
      ]
    } as FileUploaderOptions);
    this.uploader.onAfterAddingFile = file => {
      file.withCredentials = false;
    };
  }

  uploadDocument() {
    const base = this;
    this.uploader.queue.forEach(function(item) {
      item.file.name = base.uploadingDocumentName;
    });
    this.generatedId = this.guid();
    this.uploader.uploadAll();
    this.loadingService.triggerLoadingEvent(true);
  }

  triggerFileUpload(comment) {
    jQuery('#comment-' + comment.id).click();
  }

  showMentionWidget() {
    this.allUsers = [...this.users];
    this.mentionUsers = [...this.users];
    this.mentionUsers.unshift({id: 'All', name: 'All'});
    setTimeout(() => {
      this.showMentionDropdown = true;
      if (!(this.changeDetectorRef as ViewRef).destroyed) {
        this.changeDetectorRef.detectChanges();
      }
    });
  }

  closeMentionContainer() {
    this.showMentionDropdown = false;
  }

  mentionSelected($event) {
    if ($event && $event.id == 'All') {
      this.mentionIds = [{id: 'All', name: 'All'}];
      this.mentions = ['All'];
    } else if ($event) {
      const index = _.findIndex(this.mentionIds, {id: $event.id});
      if (index == -1) {
        this.mentionIds = [...this.mentionIds, $event];
        this.mentions = _.map(this.mentionIds, 'name');
      }
    }
    if (!(this.changeDetectorRef as ViewRef).destroyed) {
      this.changeDetectorRef.detectChanges();
    }
  }

  removeMention($event) {
    if ($event && $event.id == 'All') {
      this.mentionIds = [];
      this.mentions = _.map(this.mentionIds, 'name');
    } else if ($event) {
      const index = _.findIndex(this.mentionIds, {id: $event.id});
      if (index !== -1) {
        this.mentionIds = this.mentionIds.filter((entry, idx) => {
          return index != idx;
        });
      }
      this.mentions = _.map(this.mentionIds, 'name');
    }
    if (!(this.changeDetectorRef as ViewRef).destroyed) {
      this.changeDetectorRef.detectChanges();
    }
  }

  prependMentions(newComment) {
    const base = this;
    if (this.mentionIds.length > 0) {
      if (this.mentionIds[0].id == 'All') {
        this.mentionIds = [...this.allUsers];
      }
      const mentionString = _.map(this.mentionIds, function(mention) {
        return `@${mention.name}`;
      });
      newComment.mention_message = `${mentionString}:`;
      if (this.pageType == 'teams') {
        newComment.mentionIds = _.map(this.mentionIds, 'userId');
      } else {
        newComment.mentionIds = _.map(this.mentionIds, 'id');
      }
    }
  }

  handleEmojiSelection(event) {
    if (!this.updateObj.html_message) {
      this.updateObj.message += '<span title="' + event.label + '"><img class="emoji-button emoji-in-message" src="https://static.taxplaniq.com/images/emojis/' + event.char + '.png"/>></span><span> </span>';
    } else {
      this.updateObj.html_message += '<span title="' + event.label + '"><img class="emoji-button emoji-in-message" src="https://static.taxplaniq.com/images/emojis/' + event.char + '.png"/></span><span> </span>';
    }
  }

  handleSubCommnetSelection(event) {
    this.subComment += event.char;
  }

  urltoFile(url, filename, mimeType) {
    return (fetch(url)
        .then(function(res) {
          return res.arrayBuffer();
        })
        .then(function(buf) {
          return new File([buf], filename, {type: mimeType});
        })
    );
  }

  handleReaction(event) {
    if (this.comment.userReaction) {
      this.comment.allReactions[this.comment.userReaction] = this.comment.allReactions[this.comment.userReaction] - 1;
      this.comment.reactionsCount = this.comment.reactionsCount - 1;
    }
    this.comment.allReactions[event.reaction] = this.comment.allReactions[event.reaction] + 1;
    this.comment.userReaction = event.reaction;
    this.comment.reactionsCount = this.comment.reactionsCount + 1;
    this.like(event.reaction);
  }

  closeHandleContainer() {
    this.toggledGiphy = false;
    this.toggledEditGiphy = false;
    this.invokeChangeDetection();
  }

  invokeChangeDetection() {
    if (!(this.changeDetectorRef as ViewRef).destroyed) {
      this.changeDetectorRef.detectChanges();
    }
  }

  removeDocument(doc) {
    const base = this;
    for (let i = 0; i < base.documentsData.length; i++) {
      if (base.documentsData[i].id === doc.id) {
        base.documentsIds.splice(i, 1);
        base.documentsData.splice(i, 1);
      }
    }
  }

  attachFromDocs(document) {
    this.docData = document.documentsData;
    for (let i = 0; i < this.docData.length; i++) {
      this.documentsData.push(this.docData[i]);
      const obj = {
        id: this.docData[i].file.id,
        name: this.docData[i].file.name,
      };
      this.documentsIds.push(obj);
    }
    this.hideReveal('mailAttach');
  }

  displayInfo() {
    setTimeout(() => {
      this.displayUserInfoWidget = true;
      this.changeDetectorRef.detectChanges();
    });
  }

  closeDisplayInfo() {
    this.displayUserInfoWidget = false;
    this.invokeChangeDetection();
  }

  handleCommentDeleteAction(commentId) {
    const index = _.findIndex(this.comment.children, {id: commentId});
    this.comment.children.splice(index, 1);
    this.refreshPost();
    this.invokeTimeago();
  }

  refreshPost() {
    try {
      this.changeDetectionRef.detectChanges();
    } catch (e) {
      console.log('error while refreshPost', e);
    }
  }

  updateCommentData(comment) {
    if (comment && comment.id) {
      const base = this;
      this.loadingService.triggerLoadingEvent(true);
      this.collaborationService.updateCommentData(this.org, this.user.id, comment.id, comment).subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, "Failed to attach document");
      });
    }
  }

}
